import Dexie from "dexie";
import { DexieIndexKeys } from "../../dexie-index-keys";
import { IDatabaseUpgrade } from "../database-upgrade";

/**
 * Defines the upgrade path for version 14 of indexed DB.
 * This version has been deprecated but the table schema must remain for upgrade compatibility.
 * It exists only to ensure smooth upgrades for any databases that may be stuck at this version.
 */
export class DatabaseUpgradeV14 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 14;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		// Preserve table schema but no localStorage data migration
		dexieInstance.version(this.Version).stores({
			StateData: `${DexieIndexKeys.ID},
					[${DexieIndexKeys.LEGACY_ID}+${DexieIndexKeys.USER_NAME}+${DexieIndexKeys.CROWN_ID}],
					[${DexieIndexKeys.ID}+${DexieIndexKeys.USER_NAME}+${DexieIndexKeys.CROWN_ID}],
					[${DexieIndexKeys.USER_NAME}+${DexieIndexKeys.CROWN_ID}]`
		});
	}
}